<!--
 * @Author: wh
 * @Date: 2020-08-24 19:10:33
 * @LastEditTime: 2020-09-11 17:12:18
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \Web\JiYun.Mobile\src\views\leaderTerminal\DataBulletin\unitMaterialConsum.vue
-->
<template>
    <div class="unitMaterialConsum">
        <div class="search-conditions-con">
            <div class="search-conditions">
                <span class="time-con" @click="showCalendarPop=true">
                    <span>{{ date }}</span>
                </span>
                <span class="org" @click="showOrgPop=true">
                    <span class="org-name">{{ orgName }}</span>
                </span>
            </div>
        </div>

        <div class="main">
            <div class="top">
                <div class="header">
                    <div class="item item0">
                        <p class="num">
                            {{ blockConsume.volume }}
                        </p>
                        <p class="describe">
                            总生产量
                        </p>
                        <p class="describe">
                            (方)
                        </p>
                    </div>
                    <div class="item item2">
                        <p class="num">
                            {{ blockConsume.theory_gk_volume }}
                        </p>
                        <p class="describe">
                            配比用量
                        </p>
                        <p class="describe">
                            (吨)
                        </p>
                    </div>
                    <div class="item item1">
                        <p class="num">
                            {{ blockConsume.actual_value }}
                        </p>
                        <p class="describe">
                            实际用量
                        </p>
                        <p class="describe">
                            (吨)
                        </p>
                    </div>
                    <div class="item item3">
                        <p class="num">
                            {{ blockConsume.consume }}
                        </p>
                        <p class="describe">
                            单方消耗
                        </p>
                        <p class="describe">
                            (千克/方)
                        </p>
                    </div>
                </div>
                <table>
                    <thead>
                        <tr>
                            <th>原材料类型</th>
                            <th>
                                配比用量<br>(吨)
                            </th>
                            <th>
                                实际用量<br>(吨)
                            </th>
                            <th>
                                单方消耗<br>(千克/方)
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr
                            @click="selectRow(item, index)"
                            v-for="(item, index) in materialcategory"
                            :key="index"
                            :class="{'activeRow': activeRow === index}"
                        >
                            <td class="row-tit">
                                {{ item.material_category_name }}
                            </td>
                            <td>{{ item.theory_gk_volume }}</td>
                            <td>{{ item.actual_value }}</td>
                            <td>{{ item.consume }}</td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div class="split"></div>
            <div class="chart-con">
                <h4>
                    <van-tabs
                        type="card"
                        color="#3495FB"
                        v-model="tabActive"
                        @click="tabSelect"
                    >
                        <template
                            v-for="(item,index) in tabData"
                        >
                            <van-tab :key="index" :title="item.name" :disabled="item.disabled"></van-tab>
                        </template>
                    </van-tabs>
                </h4>
                <template v-if="materialcategory.length>0">
                    <div
                        v-if="tabActive===0"
                        id="lineChart"
                        class="lineChart"
                    ></div>
                    <div
                        v-else-if="tabActive===1"
                        id="stationChart"
                        class="lineChart"
                    ></div>
                    <div
                        v-else-if="tabActive===2"
                        id="catalogChart"
                        class="lineChart"
                    ></div>
                </template>
            </div>
        </div>
        <van-popup v-model="showCalendarPop" position="bottom" :style="{ height: '50%' }">
            <van-datetime-picker
                v-model="currentDate"
                type="year-month"
                title="选择年月"
                @confirm="confirmDate"
                @cancel="cancelDate"
            ></van-datetime-picker>
        </van-popup>
        <van-popup v-model="showOrgPop" position="bottom" :style="{ height: '50%' }">
            <van-picker
                show-toolbar
                title="请选择"
                :columns="columns"
                @confirm="confirmOrg"
                @cancel="cancelOrg"
            ></van-picker>
        </van-popup>
    </div>
</template>

<script>
import bg_green from '@/assets/images/home/bg_green.png';
import bg_yellow from '@/assets/images/home/bg_yellow.png';
export default {
    components: {},
    props: {},
    data() {
        return {
            // 选择时间
            showCalendarPop: false,
            // 选择组织结构
            showOrgPop: false,
            // 当前日期
            date: '',
            // 选中场站
            orgName: '全部',
            columns: [],
            // 图表数据
            data: {},
            // 场站
            StationData: [{
                station_id: '',
                station_name: '全部',
            }],
            mixstation_code: '',
            currentDate: new Date(),
            // 选中表格行index
            activeRow: 0,
            // tab选项
            tabData: [
                {
                    name: '按标号',
                    disabled: false,
                },
                {
                    name: '按场站/线',
                    disabled: false,
                },

                {
                    name: '按分类',
                    disabled: false,
                },
            ],
            tabActive: 0,
            // 顶部块数据
            blockConsume: {},
            // 原料分类
            materialcategory: [],
            // 选中原材料场站编码
            material_category_code: '',
            // 按标号统计
            gradeData: {
                xData: [],
                theory_gk_volume: [],
                actual_value: [],
                consume: [],
            },
            // 按场站统计
            stationChart: {
                xData: [],
                theory_gk_volume: [],
                actual_value: [],
                consume: [],
            },
            // 按分类
            catalogChart: {
                xData: [],
                theory_gk_volume: [],
                actual_value: [],
            },
        };
    },
    watch: {},
    computed: {},
    created() {},
    mounted() {
        this.init();
    },
    methods: {
        // 初始化页面
        init() {
            const date = new Date();
            const year = date.getFullYear();
            const month = date.getMonth() + 1;
            this.date = year + '-' + month;
            this.getStation();
            this.reLoad();
        },
        reLoad() {
            this.getBlockConsume();
            this.handleMaterialcategory();
        },
        // 拉取场站
        getStation() {
            let stationIds = this.$takeTokenParameters('StationIds');
            if (stationIds.length > 0) {
                stationIds = stationIds.split(',');
                const stationNames = this.$takeTokenParameters('StationNames').split(',');
                const stationList = stationIds.map((id, index) => {
                    return {
                        station_id: id,
                        station_name: stationNames[index],
                    };
                });
                this.StationData.push(...stationList);
                this.columns = this.StationData.map(item => item.station_name);
                this.StationName = this.columns[0];
                this.StationId = this.StationData[0].station_id;
            }
        },
        // 处理统计块
        async getBlockConsume() {
            const res = await this.getProductmaterialconsume();
            if (res) {
                this.blockConsume = res;
            }
        },
        // 处理原材料统计分类数据
        async handleMaterialcategory() {
            this.$toast.loading();
            this.materialcategory = [];
            const res = await this.getProductmaterialcategory();
            if (res) {
                this.materialcategory = res;
                if (res.length > 0) {
                    this.material_category_code = res[0].material_category_code;
                    this.tabActive = 0;
                    this.handleStatisticalstrengthgrade();
                }
            }
            this.$toast.clear();
        },
        // 按标号
        async handleStatisticalstrengthgrade() {
            const res = await this.getStatisticalstrengthgrade();
            if (res) {
                this.gradeData = {
                    xData: [],
                    theory_gk_volume: [],
                    actual_value: [],
                    consume: [],
                };
                res.map(item => {
                    this.gradeData.xData.push(item.strength_grade_name);
                    this.gradeData.theory_gk_volume.push(item.theory_gk_volume);
                    this.gradeData.actual_value.push(item.actual_value);
                    this.gradeData.consume.push(item.consume);
                });
                this.initGradeChart();
            }
        },
        // 按场站
        async handleStatisticalmixstation() {
            const res = await this.getStatisticalmixstation();
            if (res) {
                this.stationChart = {
                    xData: [],
                    theory_gk_volume: [],
                    actual_value: [],
                    consume: [],
                };
                res.map(item => {
                    this.stationChart.xData.push(item.mixstation_name);
                    this.stationChart.theory_gk_volume.push(item.theory_gk_volume);
                    this.stationChart.actual_value.push(item.actual_value);
                    this.stationChart.consume.push(item.consume);
                });
                this.initStationChart();
            }
        },
        // 按生产线
        async hanleByline() {
            const res = await this.getByline();
            if (res) {
                this.stationChart = {
                    xData: [],
                    theory_gk_volume: [],
                    actual_value: [],
                    consume: [],
                };
                res.map(item => {
                    this.stationChart.xData.push(item.line_name);
                    this.stationChart.theory_gk_volume.push(item.theory_gk_volume);
                    this.stationChart.actual_value.push(item.actual_value);
                    this.stationChart.consume.push(item.consume);
                });
                this.initStationChart();
            }
        },
        // 按分类
        async handleBycatalog() {
            const res = await this.getByCatalog();
            if (res) {
                this.catalogChart = {
                    xData: [],
                    theory_gk_volume: [],
                    actual_value: [],
                };
                res.map(item => {
                    this.catalogChart.xData.push(item.pzgg);
                    this.catalogChart.theory_gk_volume.push(item.theory_gk_volume);
                    this.catalogChart.actual_value.push(item.actual_value);
                });
                this.initCatalogChart();
            }
        },
        // 获取统计块
        getProductmaterialconsume() {
            const path = '/interfaceApi/report/productmaterialconsume';
            const data = {
                year_month: this.date,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 统计原料分类
        getProductmaterialcategory() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalmaterialcategory';
            const data = {
                year_month: this.date,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 按标号
        getStatisticalstrengthgrade() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalstrengthgrade';
            const data = {
                year_month: this.date,
                material_category_code: this.material_category_code,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 按场站
        getStatisticalmixstation() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalmixstation';
            const data = {
                year_month: this.date,
                material_category_code: this.material_category_code,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 按生产线
        getByline() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalline';
            const data = {
                year_month: this.date,
                material_category_code: this.material_category_code,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 按分类
        getByCatalog() {
            const path = '/interfaceApi/report/productmaterialconsume/statisticalmaterial';
            const data = {
                year_month: this.date,
                material_category_code: this.material_category_code,
                mixstation_code: this.mixstation_code,
            };
            return this.$axios.$post(path, data, { defEx: true });
        },
        // 选中日期
        confirmDate(value) {
            this.showCalendarPop = false;
            this.date = this.formatDate(value);
            this.reLoad();
        },
        // 取消选中日期
        cancelDate() {
            this.showCalendarPop = false;
        },
        formatDate(date) {
            date = new Date(date);
            const y = date.getFullYear();
            let m = date.getMonth() + 1;
            m = m < 10 ? '0' + m : m;
            return y + '-' + m;
        },
        // 场站确认选择
        confirmOrg(value) {
            this.showOrgPop = false;
            this.orgName = value;
            this.StationData.map(item => {
                if (item.station_name === value) {
                    this.mixstation_code = item.station_id;
                }
            });
            if (value === '全部') {
                this.mixstation_code = '';
            }
            this.reLoad();
        },
        // 场站取消选择
        cancelOrg() {
            this.showOrgPop = false;
        },
        // 选中table行
        selectRow(item, index) {
            this.material_category_code = item.material_category_code;
            this.activeRow = index;
            this.tabActive = 0;
            this.handleStatisticalstrengthgrade();
        },
        // chart切换
        async tabSelect(name) {
            this.$toast.loading();
            if (this.material_category_code) {
                this.tabActive = name;
                if (name === 0) {
                    await this.handleStatisticalstrengthgrade();
                } else if (name === 1) {
                    if (this.mixstation_code) {
                        await this.hanleByline();
                    } else {
                        await this.handleStatisticalmixstation();
                    }
                } else if (name === 2) {
                    await this.handleBycatalog();
                }
            }
            this.$toast.clear();
        },
        initCatalogChart() {
            const myChart = this.$echarts.init(document.getElementById('catalogChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 50,
                },
                legend: {
                    data: ['配比用量', '实际用量'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.catalogChart.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(吨)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#55A7FE', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#3E79C5', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.catalogChart.theory_gk_volume,
                    },
                    {
                        name: '实际用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#EFAB54', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#FA8C47', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.catalogChart.actual_value,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        initStationChart() {
            const myChart = this.$echarts.init(document.getElementById('stationChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 50,
                },
                legend: {
                    data: ['配比用量', '实际用量', '单方消耗'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.stationChart.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(吨)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#76E0A8', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#13BD63', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.stationChart.theory_gk_volume,
                    },
                    {
                        name: '实际用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#F79187', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: '#EA5D5D', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.stationChart.actual_value,
                    },
                    {
                        name: '单方消耗',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#5588F1',
                                lineStyle: {
                                    color: '#5588F1',
                                },
                            },
                        },
                        yAxisIndex: 1,
                        data: this.stationChart.consume,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
        // 量价结构分析
        initGradeChart() {
            const myChart = this.$echarts.init(document.getElementById('lineChart'));
            const option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'none',
                        crossStyle: {
                            color: '#999',
                        },
                    },
                },
                grid: {
                    left: 50,
                },
                legend: {
                    data: ['配比用量', '实际用量', '单方消耗'],
                },
                xAxis: [
                    {
                        type: 'category',
                        data: this.gradeData.xData,
                        axisPointer: {
                            type: 'shadow',
                        },
                        // 设置间隔
                        axisLabel: {
                            interval: 0,
                            fontSize: 12, // 字体大小
                            rotate: 30,
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: { show: false },
                        axisTick: { show: false },
                    },
                ],
                yAxis: [
                    {
                        type: 'value',
                        name: '(吨)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                    {
                        type: 'value',
                        name: '(千克/方)',
                        // 设置间隔
                        axisLabel: {
                            formatter: '{value}',
                            interval: 0,
                            fontSize: 12, // 字体大小
                        },
                        // 设置边框样式
                        axisLine: {
                            lineStyle: {
                                color: '#979EA7',
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                type: 'dashed',
                                color: '#F0F0F0',
                            },
                        },
                        axisTick: { show: false },
                    },
                ],
                series: [
                    {
                        name: '配比用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(113,198,176,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(78,164,150,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.theory_gk_volume,
                    },
                    {
                        name: '实际用量',
                        type: 'bar',
                        itemStyle: {
                            color: new this.$echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: 'rgba(242,227,65,1)', // 0% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(220,193,41,1)', // 100% 处的颜色
                            }], false),
                        },
                        barWidth: 10,
                        data: this.gradeData.actual_value,
                    },
                    {
                        name: '单方消耗',
                        type: 'line',
                        itemStyle: {
                            normal: {
                                color: '#FA8436',
                                lineStyle: {
                                    color: '#FA8436',
                                },
                            },
                        },
                        yAxisIndex: 1,
                        data: this.gradeData.consume,
                    },
                ],
            };
            myChart.setOption(option, true);
        },
    },
};
</script>
<style lang="stylus" scoped>
.unitMaterialConsum
    background #fff
    width 100%
    height 100%
    .search-conditions-con
        padding 10rpx
        .search-conditions
            font-size 16rpx
            height 45rpx
            box-shadow 1px 1px 4px 0px rgba(0,0,0,0.2)
            border-radius 4rpx
            padding 10rpx 20rpx
            display flex
            justify-content space-around
            line-height 25rpx
            .time-con
                position relative
                flex 1
                text-align center
                &:after
                    content ''
                    position absolute
                    right 10rpx
                    height 15rpx
                    border-right 1px solid #D7D7D7
                    margin-top 5rpx
            .iconfont
                font-size 14rpx
                color #979EA7
                margin-left 5rpx
            .org
                flex 1
                text-align center
                .org-name
                    color #3495FB
    .main
        .top
            padding 0 10rpx 10rpx 10rpx
            .header
                display flex
                margin-top 10rpx
                .item
                    flex 1
                    flex-shrink 0
                    width 25%
                    text-align center
                    .describe
                        font-size 12rpx
                    .num
                        overflow hidden
                        text-overflow ellipsis
                        white-space nowrap
                    &.item0
                        .num
                            color #5588F1
                    &.item1
                        .num
                            color #FA8436
                    &.item2
                        .num
                            color #21BDCC
                    &.item3
                        .num
                            color #FFB729
            table
                width 100%
                border-spacing 0px
                border-collapse collapse
                margin-top 10rpx
                table-layout fixed
                th
                    background rgba(235,240,252,1)
                    height 45rpx
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    font-size 14rpx
                    font-weight normal
                td
                    border 2.5rpx solid #fff
                    border-collapse collapse
                    height 45rpx
                    text-align center
                    width 40rpx
                    font-size 14rpx
                    background rgba(85,136,241,.04)
                    width 25%
                    color #5588F1
                    &.row-tit
                        color #333333
                        background rgba(235,240,252,1)
                tbody
                    tr
                        &.activeRow
                            td
                                background rgba(250,132,54,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                color #fff
                            .row-tit
                                color #823802
                                background rgba(245,242,237,1)
                                box-shadow 1px 1px 4px 0px rgba(0,0,0,0.3)
                                border 1px solid rgba(222,227,239,1)
        .split
            background #F0F0F0
            height 15rpx
        .chart-con
            padding 10rpx
            h4
                margin 10rpx 0
            .lineChart
                width 95%
                margin-left 5%
                height 235rpx
            h5
                text-align center
                margin-top 20rpx
</style>
